import React from "react";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import {routes} from './routes'
import { RecoilRoot, atom, selector } from 'recoil';
import {
    AuthenticationProvider,
    ThemeProvider,
    MessageProvider,
    ConfirmProvider,
    AppProvider,
    MessageReferenceProvider
  } from "@commons/Providers";
import './Assets/css/_typography.css'
import "./Assets/scss/light-bootstrap-dashboard-pro-react.scss?v=2.0.0";
import "./Assets/css/demo.css";
import '../../styles/vendors/Draft.css'
import {FormalizarWithLoading, Carta} from "@commons/Componentes";
import {MessageProvider as ReportesMessageProvider}  from '@commons/Componentes/Message.jsx'
import {Top5Cxc} from "@cxc/top5Cxc.jsx";
import {Top5Cxp} from "@cxp/top5Cxp.jsx";

import {GridCxc, GraficosCxc,TarjetasCxc,Top10Cxc, EstadoResultado as EstadoCuenta, SaldoAntiguedad} from '@cxc/Componentes'
import {TarjetasBanco,GridBanco,GraficosBanco, ReporteDocuemtosBancarios, Banco } from '@activos/Componentes'
import {GridContabilidad, TarjetasContabilidad, GraficosContabilidad, FiltrosTop10, BalanceComprabacion, BalanceGeneralMain, EstadoResultado} from "@contabilidad/Componentes";
import {Top10Cxp, TarjetasCxp, GraficosCxp, GridCxp, SaldoAntiguedad as SaldoAntiguedadCXP,EstadoResultado as EstadoCuentaCXP } from "@cxp/Componentes";
import {GridFacturacion, GraficosFacturacion, TarjetasFacturacion, Top10Facturacion, GraficoVentas, GraficoRentabilidad, RentabilidadPorItemGrid} from "@facturacion/Componentes"
import {GridInventario, GraficosInventario, TarjetasInventario, GraficosPorItem} from "@inventario/Componentes"
import {GridEmpleadosRRHH,GridRRHH,GraficosRRHH,TarjetasRRHH} from "@nomina/Componentes"
import {Reporte607, Reporte606} from "@impuesto/Componentes"
import {LoginPageWithLoading,FuncionesPerfil} from "@seguridad/Components"

function ProviderWrapper({children}){
    return (
            <AppProvider>
                <AuthenticationProvider>
                    <ThemeProvider>
                        <MessageProvider>
                            <ConfirmProvider>
                                {children}
                            </ConfirmProvider>
                        </MessageProvider>
                    </ThemeProvider>
                </AuthenticationProvider>
            </AppProvider>
    )
}

function Root () {
    const router = createBrowserRouter(routes);
    return (
            <RecoilRoot>
                <AppProvider>
                    <AuthenticationProvider>
                        <ThemeProvider>
                            <MessageProvider>
                                <ConfirmProvider>
                                    <RouterProvider router={router}>
                                    </RouterProvider>
                                </ConfirmProvider>
                            </MessageProvider>
                        </ThemeProvider>
                    </AuthenticationProvider>
                </AppProvider>
            </RecoilRoot>
    )
}
if(document.getElementById("MainRoot")){
    // eslint-disable-next-line no-restricted-globals
    if (!parent.document.getElementById("CitrusFRM")) {
        const app = document.getElementById("MainRoot");
        const root = ReactDOM.createRoot(app);
        root.render(<Root/>);
    }    
}

//renderizar formalizar
function FormalizarRoot(){
    return (
        <AppProvider>
            <AuthenticationProvider>
                <ThemeProvider>
                    <MessageProvider>
                        <MessageReferenceProvider>
                            <ConfirmProvider>
                                <FormalizarWithLoading />
                            </ConfirmProvider>
                        </MessageReferenceProvider>
                    </MessageProvider>
                </ThemeProvider>
            </AuthenticationProvider>
        </AppProvider>
    )
}
if(document.getElementById('formalizarApp')){
    const formalizarApp = document.getElementById("formalizarApp");
    const formalizarRoot = ReactDOM.createRoot(formalizarApp);
    formalizarRoot.render(<FormalizarRoot/>);   
}

//renderizar login
function LoginRoot(){
    return (
        <AppProvider>
                <ThemeProvider>
                    <MessageProvider>
                        <MessageReferenceProvider>
                            <ConfirmProvider>
                                <LoginPageWithLoading />
                            </ConfirmProvider>
                        </MessageReferenceProvider>
                    </MessageProvider>
                </ThemeProvider>
        </AppProvider>
    )
}
if(document.getElementById('LoginPage')){
    const loginApp = document.getElementById("LoginPage");
    const loginRoot = ReactDOM.createRoot(loginApp);
    loginRoot.render(< LoginRoot/>);
}

//Reportes Dinamicos
function EstadoResultadoRoot(){
    return (
        <ReportesMessageProvider>
            <EstadoResultado />
        </ReportesMessageProvider>
    )
}
if(document.getElementById('estado-resultado-app')){
    const estadoResultadoApp = document.getElementById("estado-resultado-app");
    const estadoResultadoRoot = ReactDOM.createRoot(estadoResultadoApp);
    estadoResultadoRoot.render(< EstadoResultadoRoot/>);
}

function BalanceGeneralRoot(){
    return (
        <ReportesMessageProvider>
            <BalanceGeneralMain />
        </ReportesMessageProvider>
    )
}
if(document.getElementById('balance-general-app')){
    const balanceGeneralApp = document.getElementById("balance-general-app");
    const balanceGeneralRoot = ReactDOM.createRoot(balanceGeneralApp);
    balanceGeneralRoot.render(< BalanceGeneralRoot/>);
}

function BalanzaComprobacionRoot(){
    return (
        <ReportesMessageProvider>
            <BalanceComprabacion />
        </ReportesMessageProvider>
    )
}
if(document.getElementById('balanza-comprobacion-app')){
    const BalanzaComparacionApp = document.getElementById("balanza-comprobacion-app");
    const BalanzaComparacionRoot = ReactDOM.createRoot(BalanzaComparacionApp);
    BalanzaComparacionRoot.render(< BalanzaComprobacionRoot/>);
}

function EstadoCuentaRoot(){
    return (
        <AuthenticationProvider>
        <ReportesMessageProvider>
            <EstadoCuenta />
        </ReportesMessageProvider>
        </AuthenticationProvider>
    )
}
if(document.getElementById('estado-cuenta-app')){
    const estadoCuentaApp = document.getElementById("estado-cuenta-app");
    const estadoCuentaRoot = ReactDOM.createRoot(estadoCuentaApp);
    estadoCuentaRoot.render(< EstadoCuentaRoot/>);
}

function SaldoAntiguedadRoot(){
    return (
        <AuthenticationProvider>
        <ReportesMessageProvider>
            <SaldoAntiguedad />
        </ReportesMessageProvider>
        </AuthenticationProvider>
    )
}
if(document.getElementById('saldo-antiguedad-app')){
    const saldoAntiguedadApp = document.getElementById("saldo-antiguedad-app");
    const saldoAntiguedadRoot = ReactDOM.createRoot(saldoAntiguedadApp);
    saldoAntiguedadRoot.render(< SaldoAntiguedadRoot/>);
}

function EstadoCuentaCXPRoot(){
    return (
        <ReportesMessageProvider>
            <EstadoCuentaCXP />
        </ReportesMessageProvider>
    )
}
if(document.getElementById('estado-cuenta-cxp-app')){
    const estadoCuentaCxpApp = document.getElementById("estado-cuenta-cxp-app");
    const estadoCuentaCxpRoot = ReactDOM.createRoot(estadoCuentaCxpApp);
    estadoCuentaCxpRoot.render(< EstadoCuentaCXPRoot/>);
}

function SaldoAntiguedadCXPRoot(){
    return (
        <AuthenticationProvider>
        <ReportesMessageProvider>
            <SaldoAntiguedadCXP />
        </ReportesMessageProvider>
        </AuthenticationProvider>
    )
}
if(document.getElementById('saldo-antiguedad-cxp-app')){
    const saldoAntiguedadCxpApp = document.getElementById("saldo-antiguedad-cxp-app");
    const saldoAntiguedadCxpRoot = ReactDOM.createRoot(saldoAntiguedadCxpApp);
    saldoAntiguedadCxpRoot.render(< SaldoAntiguedadCXPRoot/>);
}

function ReporteDocuemtosBancariosRoot(){
    return (
        <ReportesMessageProvider>
            <ReporteDocuemtosBancarios />
        </ReportesMessageProvider>
    )
}
if(document.getElementById('banco-reporte-app')){
    const documentoBancarioApp = document.getElementById("banco-reporte-app");
    const documentoBancarioRoot = ReactDOM.createRoot(documentoBancarioApp);
    documentoBancarioRoot.render(< ReporteDocuemtosBancariosRoot/>);
}

function Reporte606Root(){
    return (
        <ReportesMessageProvider>
            <Reporte606 />
        </ReportesMessageProvider>
    )
}
if(document.getElementById('reporte-606-app')){
    const reporte606App = document.getElementById("reporte-606-app");
    const reporte606Root = ReactDOM.createRoot(reporte606App);
    reporte606Root.render(< Reporte606Root/>);
}

function Reporte607Root(){
    return (
        <ReportesMessageProvider>
            <Reporte607 />
        </ReportesMessageProvider>
    )
}
if(document.getElementById('reporte-607-app')){
    const reporte607App = document.getElementById("reporte-607-app");
    const reporte607Root = ReactDOM.createRoot(reporte607App);
    reporte607Root.render(< Reporte607Root/>);
}

// funciones perfil
if(document.getElementById('funciones-perfil-app')){
    const funcionesPerfilApp = document.getElementById("funciones-perfil-app");
    const funcionesPerfilRoot = ReactDOM.createRoot(funcionesPerfilApp);
    funcionesPerfilRoot.render(< FuncionesPerfil/>);
}

if(document.getElementById('prestamo-financiero-react-app')){
    const prestamoFinancieroApp = document.getElementById("prestamo-financiero-react-app");
    const prestamoFinancieroRoot = ReactDOM.createRoot(prestamoFinancieroApp);
    prestamoFinancieroRoot.render(<Carta />);
}

//dashboards
if(document.getElementById('Grid-Banco')){
    const dashboardBancoApp = document.getElementById("Grid-Banco");
    const dashboardBancoRoot = ReactDOM.createRoot(dashboardBancoApp);
    dashboardBancoRoot.render(<ProviderWrapper>< GridBanco/></ProviderWrapper>);
}
if(document.getElementById('Graficos-Banco')){
    const GraficosBancoApp = document.getElementById("Graficos-Banco");
    const GraficosBancoAppRoot = ReactDOM.createRoot(GraficosBancoApp);
    GraficosBancoAppRoot.render(<ProviderWrapper>< GraficosBanco/></ProviderWrapper>);
}
if(document.getElementById('Tarjetas-Banco')){
    const TarjetasBancoApp = document.getElementById("Tarjetas-Banco");
    const TarjetasBancoRoot = ReactDOM.createRoot(TarjetasBancoApp);
    TarjetasBancoRoot.render(< TarjetasBanco/>);
}

if(document.getElementById('Grid-Contabilidad')){
    const dashboardContabilidadApp = document.getElementById("Grid-Contabilidad");
    const dashboardContabilidadRoot = ReactDOM.createRoot(dashboardContabilidadApp);
    dashboardContabilidadRoot.render(<ProviderWrapper>< GridContabilidad/></ProviderWrapper>);
}
if(document.getElementById('Graficos-Contabilidad')){
    const GraficosContabilidadApp = document.getElementById("Graficos-Contabilidad");
    const GraficosContabilidadAppRoot = ReactDOM.createRoot(GraficosContabilidadApp);
    GraficosContabilidadAppRoot.render(<ProviderWrapper>< GraficosContabilidad/></ProviderWrapper>);
}
if(document.getElementById('Tarjetas-Contabilidad')){
    const TarjetasContabilidadApp = document.getElementById("Tarjetas-Contabilidad");
    const TarjetasContabilidadRoot = ReactDOM.createRoot(TarjetasContabilidadApp);
    TarjetasContabilidadRoot.render(< TarjetasContabilidad/>);
}
if(document.getElementById('Top10-Contabilidad')){
    const Top10ContabilidadApp = document.getElementById("Top10-Contabilidad");
    const Top10ContabilidadRoot = ReactDOM.createRoot(Top10ContabilidadApp);
    Top10ContabilidadRoot.render(< FiltrosTop10/>);
}

if(document.getElementById('Grid-Cxc')){
    const dashboardCxcApp = document.getElementById("Grid-Cxc");
    const dashboardCxcRoot = ReactDOM.createRoot(dashboardCxcApp);
    dashboardCxcRoot.render(<ProviderWrapper>< GridCxc/></ProviderWrapper>);
}
if(document.getElementById('Graficos-Cxc')){
    const GraficosCxcApp = document.getElementById("Graficos-Cxc");
    const GraficosCxcAppRoot = ReactDOM.createRoot(GraficosCxcApp);
    GraficosCxcAppRoot.render(<ProviderWrapper>< GraficosCxc/></ProviderWrapper>);
}
if(document.getElementById('Tarjetas-Cxc')){
    const TarjetasCxcApp = document.getElementById("Tarjetas-Cxc");
    const TarjetasCxcRoot = ReactDOM.createRoot(TarjetasCxcApp);
    TarjetasCxcRoot.render(< TarjetasCxc/>);
}
if(document.getElementById('Top10-Cxc')){
    const Top10CxcApp = document.getElementById("Top10-Cxc");
    const Top10CxcRoot = ReactDOM.createRoot(Top10CxcApp);
    Top10CxcRoot.render(< Top10Cxc/>);
}

if(document.getElementById('Grid-Cxp')){
    const dashboardCxpApp = document.getElementById("Grid-Cxp");
    const dashboardCxpRoot = ReactDOM.createRoot(dashboardCxpApp);
    dashboardCxpRoot.render(<ProviderWrapper>< GridCxp/></ProviderWrapper>);
}
if(document.getElementById('Graficos-Cxp')){
    const GraficosCxpApp = document.getElementById("Graficos-Cxp");
    const GraficosCxpAppRoot = ReactDOM.createRoot(GraficosCxpApp);
    GraficosCxpAppRoot.render(<ProviderWrapper>< GraficosCxp/></ProviderWrapper>);
}
if(document.getElementById('Tarjetas-Cxp')){
    const TarjetasCxpApp = document.getElementById("Tarjetas-Cxp");
    const TarjetasCxpRoot = ReactDOM.createRoot(TarjetasCxpApp);
    TarjetasCxpRoot.render(< TarjetasCxp/>);
}
if(document.getElementById('Top10-Cxp')){
    const Top10CxpApp = document.getElementById("Top10-Cxp");
    const Top10CxpRoot = ReactDOM.createRoot(Top10CxpApp);
    Top10CxpRoot.render(< Top10Cxp/>);
}

if(document.getElementById('Grid-Facturacion')){
    const dashboardFacturacionApp = document.getElementById("Grid-Facturacion");
    const dashboardFacturacionRoot = ReactDOM.createRoot(dashboardFacturacionApp);
    dashboardFacturacionRoot.render(        
    <ProviderWrapper>
        <GridFacturacion />
    </ProviderWrapper>
    );
}
if(document.getElementById('Graficos-Facturacion')){
    const GraficosFacturacionApp = document.getElementById("Graficos-Facturacion");
    const GraficosFacturacionAppRoot = ReactDOM.createRoot(GraficosFacturacionApp);
    GraficosFacturacionAppRoot.render(<ProviderWrapper>< GraficosFacturacion/></ProviderWrapper>);
}
if(document.getElementById('Tarjetas-Facturacion')){
    const TarjetasFacturacionApp = document.getElementById("Tarjetas-Facturacion");
    const TarjetasFacturacionRoot = ReactDOM.createRoot(TarjetasFacturacionApp);
    TarjetasFacturacionRoot.render(< TarjetasFacturacion/>);
}
if(document.getElementById('Top10-Facturacion')){
    const Top10FacturacionApp = document.getElementById("Top10-Facturacion");
    const Top10FacturacionRoot = ReactDOM.createRoot(Top10FacturacionApp);
    Top10FacturacionRoot.render(< Top10Facturacion/>);
}
if (document.getElementById('Graficos-Rentabilidad')) {
    const GraficosRentabilidadApp = document.getElementById("Graficos-Rentabilidad");
    const GraficosRentabilidadRoot = ReactDOM.createRoot(GraficosRentabilidadApp);
    GraficosRentabilidadRoot.render(<ProviderWrapper><GraficoRentabilidad /></ProviderWrapper>);
}
if (document.getElementById('Grid-Facturacion-Items')) {
    const RentabilidadPorItemGridApp = document.getElementById("Grid-Facturacion-Items");
    const RentabilidadPorItemGridRoot = ReactDOM.createRoot(RentabilidadPorItemGridApp);
    RentabilidadPorItemGridRoot.render(        
        <ProviderWrapper>
            <RentabilidadPorItemGrid />
        </ProviderWrapper>
    );
}

if(document.getElementById('Grid-Inventario')){
    const dashboardInventarioApp = document.getElementById("Grid-Inventario");
    const dashboardInventarioRoot = ReactDOM.createRoot(dashboardInventarioApp);
    dashboardInventarioRoot.render(<ProviderWrapper>< GridInventario/></ProviderWrapper>);
}
if(document.getElementById('Graficos-Inventario')){
    const GraficosInventarioApp = document.getElementById("Graficos-Inventario");
    const GraficosInventarioAppRoot = ReactDOM.createRoot(GraficosInventarioApp);
    GraficosInventarioAppRoot.render(<ProviderWrapper>< GraficosInventario/></ProviderWrapper>);
}
if(document.getElementById('Tarjetas-Inventario')){
    const TarjetasInventarioApp = document.getElementById("Tarjetas-Inventario");
    const TarjetasInventarioRoot = ReactDOM.createRoot(TarjetasInventarioApp);
    TarjetasInventarioRoot.render(< TarjetasInventario/>);
}
if(document.getElementById('Graficos-Inventario-Por-Item')){
    const TarjetasInventarioApp = document.getElementById("Graficos-Inventario-Por-Item");
    const TarjetasInventarioRoot = ReactDOM.createRoot(TarjetasInventarioApp);
    TarjetasInventarioRoot.render(<ProviderWrapper>< GraficosPorItem/></ProviderWrapper>);
}

if(document.getElementById('Grid-RRHH')){
    const dashboardRRHHApp = document.getElementById("Grid-RRHH");
    const dashboardRRHHRoot = ReactDOM.createRoot(dashboardRRHHApp);
    dashboardRRHHRoot.render(<ProviderWrapper>< GridRRHH/></ProviderWrapper>);
}
if(document.getElementById('Graficos-RRHH')){
    const GraficosRRHHApp = document.getElementById("Graficos-RRHH");
    const GraficosRRHHAppRoot = ReactDOM.createRoot(GraficosRRHHApp);
    GraficosRRHHAppRoot.render(<ProviderWrapper>< GraficosRRHH/></ProviderWrapper>);
}
if(document.getElementById('GridEmpleado-RRHH')){
    const GridEmpleadoApp = document.getElementById("GridEmpleado-RRHH");
    const GridEmpleadoAppRoot = ReactDOM.createRoot(GridEmpleadoApp);
    GridEmpleadoAppRoot.render(<ProviderWrapper>< GridEmpleadosRRHH/></ProviderWrapper>);
}
if(document.getElementById('Tarjetas-RRHH')){
    const TarjetasRRHHApp = document.getElementById("Tarjetas-RRHH");
    const TarjetasRRHHRoot = ReactDOM.createRoot(TarjetasRRHHApp);
    TarjetasRRHHRoot.render(< TarjetasRRHH/>);
}

if(document.getElementById('cxpTop5')){
    const cxpTop5App = document.getElementById("cxpTop5");
    const cxpTop5Root = ReactDOM.createRoot(cxpTop5App);
    cxpTop5Root.render(< Top5Cxp/>);
}
if(document.getElementById('banco')){
    const bancoApp = document.getElementById("banco");
    const bancoRoot = ReactDOM.createRoot(bancoApp);
    bancoRoot.render(< Banco/>);
}
if(document.getElementById('cxcTop5')){
    const cxcTop5App = document.getElementById("cxcTop5");
    const cxcTop5Root = ReactDOM.createRoot(cxcTop5App);
    cxcTop5Root.render(< Top5Cxc/>);
}
if(document.getElementById('graficoVentas')){
    const graficoVentasApp = document.getElementById("graficoVentas");
    const graficoVentasRoot = ReactDOM.createRoot(graficoVentasApp);
    graficoVentasRoot.render(< GraficoVentas/>);
}
